export default "__VITE_ASSET__C25p8kAE__"